export const ADD_ERROR = 'Errors/ADD_ERROR';
export const CLEAR_ERROR = 'Errors/CLEAR_ERROR';



// WEBPACK FOOTER //
// ./src/containers/Errors/store/constants.js